import { create } from 'zustand';

type AppTheme = 'dark' | 'light';

interface ThemeState {
  appTheme: AppTheme;
  setAppTheme: (theme: AppTheme) => void;
  toggleAppTheme: () => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  appTheme: (localStorage.getItem('app-theme') as AppTheme) || 'dark',
  setAppTheme: (theme) => {
    localStorage.setItem('app-theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
    set({ appTheme: theme });
  },
  toggleAppTheme: () => {
    set((state) => {
      const next = state.appTheme === 'dark' ? 'light' : 'dark';
      localStorage.setItem('app-theme', next);
      document.documentElement.setAttribute('data-theme', next);
      return { appTheme: next };
    });
  },
}));
